{{#each incdirs}}
+incdir+{{ relativePath }}{{#each generatableFiles}} {{ ../relativePath }}/{{ fileName }}{{/each}}
{{/each}}
